export const ANY_QUERY_TIMEOUT = 1500;
